import { defaultIconProps, IconProps } from './IconProps';

export const IconSortAsc: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 3.33331V16.6666M10 16.6666L15 11.6666M10 16.6666L5 11.6666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconSortAsc.defaultProps = defaultIconProps;
